import {Component, OnInit, ViewEncapsulation} from "@angular/core";
import {PaginatedBaseComponent} from "src/app/shared/paginated-base-component/paginated-base-component";
import {ActivatedRoute, RouterModule} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {QuoteService} from "../../../_services/quote.service";
import {StateManagementService} from "../../../_services/state-management.service";
import {QuoteSearchCriteria} from "../../../_models/QuoteSearchCriteria";
import {Quote} from "../../../_models/Quote";
import {NgSelectConfig, NgSelectModule} from "@ng-select/ng-select";
import {QuoteStatus} from "../../../_models/enums/QuoteStatus";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {SharedModule} from "../../../shared/shared.module";
import {TableSortWrapper} from "../../../shared/table-sort/ts-wrapper.directive";
import {map} from "rxjs/operators";
import {AuthService} from "../../../_services/auth.service";
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: true,
  templateUrl: './my-quotes.component.html',
  imports: [
    CommonModule,
    NgSelectModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    FormsModule,
    TableSortWrapper,
    NgbPaginationModule
  ],
  encapsulation: ViewEncapsulation.None
})


export class MyQuotesComponent extends PaginatedBaseComponent implements OnInit {
  constructor(private quoteService: QuoteService, private stateManager: StateManagementService, private ngSelectConfig: NgSelectConfig,
              protected toaster: ToastrService, protected route: ActivatedRoute, private authService: AuthService) {
    super(toaster, route);

    this.searchCriteria = this.stateManager.getState<QuoteSearchCriteria>(this.FilterKey, {pageNumber: 1} as QuoteSearchCriteria);
    this.totalItems = 0;
    this.ngSelectConfig.bindValue = 'id';
  }

  public searchCriteria: QuoteSearchCriteria;
  public quotes: Quote[] = [];
  userId = '';
  public totalItems: number;
  private readonly FilterKey = 'p-quote-filter';
  searchStatus?: string;
  public statuses: any[] = Object.keys(QuoteStatus).map(x => {
    return {id: x, name: x}
  })

  ngOnInit() {
    this.authService.userProfile$.pipe(map(userProfile => {
      this.userId = userProfile.id
    })).subscribe();

    this.getQuotes();
  }

  getQuotes() {
    this.searchCriteria.pageSize = 11;
    this.searchCriteria.hasContractNumber = false;
    this.quoteService.getQuotes(this.searchCriteria).subscribe(quotes => {
      this.quotes = quotes.items;
      this.totalItems = quotes.totalCount;
      this.stateManager.setState(this.FilterKey, this.searchCriteria);
      this.paginationUpdated(this.searchCriteria.pageNumber);
      this.searchStatus = null;
    });
  }

  setPage(page: number) {
    this.searchCriteria.pageNumber = page;
    this.getQuotes();
  }

  clearFilter() {
    this.stateManager.clearState(this.FilterKey);
    this.searchCriteria = new QuoteSearchCriteria();
  }
}
